export async function readClipboardText(): Promise<string> {
	return await navigator.clipboard.readText();
}